module.exports = __webpack_public_path__ + "img/074_thumbnail.0e786e03.jpg";